import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ILevel } from "src/models/Products/Level.models";

interface LevelState {
  levels: ILevel[];
  levelToEdit: ILevel | null;
}

const initialState: LevelState = {
  levels: [],
  levelToEdit: null,
};

const LevelSlice = createSlice({
  name: "Level",
  initialState,
  reducers: {
    setLevelList: (state, action: PayloadAction<ILevel[]>) => {
      state.levels = action.payload;
    },
    concatListLevel: (state: LevelState, action: PayloadAction<ILevel[]>) => {
      state.levels = [...state.levels.concat(action.payload)];
    },
    setLevelToEdit: (state, action: PayloadAction<ILevel | null>) => {
      state.levelToEdit = action.payload;
    },
    addLevel: (state, action: PayloadAction<ILevel>) => {
      state.levels.push(action.payload);
    },
    updateLevel: (state, action: PayloadAction<ILevel>) => {
      let itemIndex = state.levels.findIndex(
        item => item.levelId === action.payload.levelId
      );
      if (itemIndex !== -1) state.levels[itemIndex] = action.payload;
    },
    deleteLevel: (state, action: PayloadAction<number>) => {
      const newArray = state.levels.filter(
        item => item.levelId !== action.payload
      );
      state.levels = newArray;
    },
  },
});

export const {
  setLevelList,
  concatListLevel,
  setLevelToEdit,
  addLevel,
  updateLevel,
  deleteLevel,
} = LevelSlice.actions;

export default LevelSlice.reducer;
